import { oz } from '@weft/utils';
import { ChannelTypeSchema } from '../notification-subscription';
import { NotificationAlertStatusSchema } from './notification-status-schema';

export const NotificationAlertSchema = oz.object({
  id: oz.string(),
  status: NotificationAlertStatusSchema,
  channelType: ChannelTypeSchema,
});

export type NotificationAlert = oz.infer<typeof NotificationAlertSchema>;